import { ContentEditable as LexicalContentEditable } from '@lexical/react/LexicalContentEditable';
import { chakra } from '@chakra-ui/react';

export const ContentEditable = chakra(LexicalContentEditable, {
  baseStyle: {
    width: '100%',
    height: '200px',
    padding: 2,
    overflow: 'auto',
    fontSize: '1em',
    resize: 'vertical',

    _focus: {
      outline: 'none',
    },

    '.paragraph': {
      margin: 0,
      marginBottom: 4,

      '&:last-child': {
        marginBottom: 0,
      },
    },

    '.bold': {
      fontWeight: 'bold',
    },

    '.italic': {
      fontStyle: 'italic',
    },

    '.underline': {
      textDecoration: 'underline',
    },

    ul: {
      mb: 4,
      ml: 4,
    },
    ol: {
      mb: 4,
      ml: 4,
    },

    a: {
      textDecoration: 'underline',
      color: 'primary',
    },
  },
});
